import React from 'react';
import { GlobeIcon, TrophyIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
const rows = [{
  label: '6 Premium Clinical Volumes',
  value: '$197'
}, {
  label: '5 Clinical Tools & Bonuses',
  value: '$185'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-143" data-mp="1hqiml1iliamt">
      <div className="mx-auto w-full max-w-xl" data-id="element-144" data-mp="tz3h4zvivd7c">
        <header className="mb-8 text-center" data-id="element-145" data-mp="p0a2330l7e52">
          <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-lime sm:text-xs" data-id="element-146" data-mp="p1l7t8dlevyt">
            🏆 Today’s offer
          </p>
          <h2 className="font-display text-2xl leading-tight text-white sm:text-4xl" data-id="element-147" data-mp="yy7pjoamh6wm">
            Get the complete Anti-Refinement System™ today
          </h2>
          <p className="mt-3 text-sm text-white/65 sm:text-base" data-id="element-148" data-mp="2fad4jky754fs">
            Everything you need to approach aligner treatment with greater predictability.
          </p>
        </header>

        <div className="rounded-3xl border border-lime/30 bg-ink-950 p-5 shadow-[0_30px_80px_-40px_rgba(198,230,43,0.5)] sm:p-7" data-id="element-149" data-mp="pjp8ru1dymmr">
          <div className="flex items-center gap-2 border-b border-white/10 pb-3" data-id="element-150" data-mp="ul4ttm3kct55">
            <TrophyIcon className="h-4 w-4 text-lime" data-id="element-151" data-mp="zgag4m0vo9tr" />
            <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-white/70" data-id="element-152" data-mp="13iyqwz95jqtd">
              What’s included
            </h3>
          </div>

          <ul className="divide-y divide-white/5" data-id="element-153" data-mp="6rwg60q8b3fk">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 py-3" data-id="element-154" data-mp="bqpvzzszn6iw">
                <span className="text-sm text-white/80 sm:text-base" data-id="element-155" data-mp="ft4geocb2eca">{row.label}</span>
                <span className="shrink-0 text-sm font-bold text-white/50 line-through sm:text-base" data-id="element-156" data-mp="kmp4noo3jtya">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-3 py-3" data-id="element-157" data-mp="3o8win45zahx9">
              <span className="text-sm font-black uppercase tracking-wide text-white sm:text-base" data-id="element-158" data-mp="vf7b8aa8w48w">
                Total value
              </span>
              <span className="shrink-0 font-display text-lg text-white/50 line-through sm:text-xl" data-id="element-159" data-mp="qge0uqq98tcy">
                $382
              </span>
            </li>
          </ul>

          <div className="mt-5 rounded-2xl bg-lime/[0.07] p-5 text-center" data-id="element-160" data-mp="107s5te0z6ldh">
            <p className="text-xs font-bold uppercase tracking-wide text-white/60" data-id="element-161" data-mp="cg36vetneynk">
              Today you don’t pay $382. You don’t even pay $97.
            </p>
            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] text-lime" data-id="element-162" data-mp="7k4pwcangix6">
              Get everything today for just
            </p>
            <p className="font-display text-5xl leading-none text-lime sm:text-6xl" data-id="element-163" data-mp="hewpflnslful">$27</p>
            <p className="mt-1 text-xs font-bold uppercase tracking-wide text-white/60" data-id="element-164" data-mp="1wvoocofz3qrc">USD</p>
            <p className="mt-3 text-xs text-white/55" data-id="element-165" data-mp="1svwbhzjjqyg6">
              One-time payment · No subscription · Lifetime access
            </p>
            <p className="mt-3 flex items-center justify-center gap-1.5 rounded-xl bg-black/40 px-3 py-2 text-[11px] font-semibold text-white/70 sm:text-xs" data-id="element-166" data-mp="20dcemelcqexr">
              <GlobeIcon className="h-4 w-4 shrink-0 text-lime" data-id="element-167" data-mp="1qh9flhlsqwf1" />
              Currency conversion is automatic — you pay in your local currency.
            </p>
          </div>

          <div className="mt-5" data-id="element-168" data-mp="2j5ezy38xujec">
            <CtaButton label="Get the Anti-Refinement System™" sub="Instant download · Lifetime access · 7-day guarantee" data-id="element-169" data-mp="2j6gam6m1l3vj" />
          </div>

          <div className="mt-6" data-id="element-170" data-mp="29g3sel1p9msk">
            <CountdownTimer data-id="element-171" data-mp="29esn2gslw6zc" />
          </div>

          <div className="mt-6" data-id="element-172" data-mp="2ee5ap3raxi2z">
            <ScarcityBar data-id="element-173" data-mp="2eddhfzl6fwfv" />
          </div>
        </div>
      </div>
    </section>;
}